import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import { useCookies } from "react-cookie";

import peoplePng from 'assets/images/business_1.png';

import {
  Container,
  Header,
  Title,
  CloseIcon,
  Content,
  ContentImg,
  ContentInfos,
  ContentButtons,
  Button,
} from "./styles";

const BannerIncentivoBoletoDigital = () => {
  const [show, setShow] = useState(false);
  const [cookies, setCookie] = useCookies(["bannerIsViewer"]);

  const handleShow = async () => {
    const unitDataString = localStorage.getItem("@UltragazEmpresarial:unitData");

    if (unitDataString) {
      const unitData = JSON.parse(unitDataString);
      const { deliveryType } = unitData || {};
      if (!deliveryType) return;

      const cookieBannerIsViewer = cookies.bannerIsViewer;

      if (deliveryType === "CORREIO" && !cookieBannerIsViewer) {
        setCookie("bannerIsViewer", "true", {
          maxAge: 60 * 60 * 24 * 7, // 1 semana
        });

        setShow(true);
      }
    }
  };

  useEffect(() => {
    const unitData = localStorage.getItem("@UltragazEmpresarial:unitData");
    let interval = null;
    if(!unitData) {
     interval = setInterval(() => {
        handleShow();
        if(interval) {
          clearInterval(interval)
        }
      }, [500])
      return;
    } else {
      handleShow();
    }
  }, []);

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="lg"
      animation={false}
      centered
    >
      <Container>
        <Header>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={() => setShow(false)} />
        </Header>
        <Content>
          <ContentImg src={peoplePng} />
          <ContentInfos>
            <Title>Conta de gás 100% digital: <span>mais prática para você, mais sustentável para o planeta!</span></Title>

            <ContentButtons>
              <Button
                to={{
                  pathname: `/preferencia-cobranca`,
                }}
              >
                Aderir ao recebimento do boleto por e-mail
              </Button>
            </ContentButtons>
          </ContentInfos>
        </Content>
      </Container>
    </Modal>
  );
};

export default BannerIncentivoBoletoDigital;
